import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Modal from "../../../components/modal";
import Input from "../../../components/input";
import LoadingSpinner from '../../../components/loading-spinner';
import {clear_teams, CREATE_TEAM, getAllTeams, createTeam} from "../../../redux/teams";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";

const Teams = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_teams = useSelector((state) => state.teams_module._get_all_teams);
    const _get_all_user_types = useSelector((state) => state.user_types_module._get_all_user_types);
    const _create_team = useSelector((state) => state.teams_module._create_team);

    const [data, setData] = useState([]);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        if (_get_all_teams.data.datos) {
            setData(_get_all_teams.data.datos);
        }
    }, [_get_all_teams]);

    const [userTypes, setUserTypes] = useState([]);

    useEffect(() => {
        if (_get_all_user_types.data.datos) {
            setUserTypes(_get_all_user_types.data.datos);
        }
    }, [_get_all_user_types]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [form, setForm] = useState({
        nombre: "",
        tipo_usuario: "",
        id_tipo_usuario: 0,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_teams').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        history.push(`/equipo/detalle/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    useEffect(() => {
        if (_create_team.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_teams(CREATE_TEAM));
            dispatch(getAllTeams(token));
            setIsLoading(false);
            setModal(false);
            history.push(`/equipo/detalle/${_create_team.data.datos.id}`);
        } else if (_create_team.status !== 0) {
            dispatch(clear_teams(CREATE_TEAM));
            toast.error(_create_team.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_team, dispatch, history, token]);

    const handleChange = (e) => {
        if (e.target.name === "id_tipo_usuario") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.id_tipo_usuario === 0) {
            toast.error("Debe seleccionar el tipo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createTeam(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Equipos", link: "/equipos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_teams').length > 0 ?
                                        <Button type="button" text="Crear" theme="calendar" onClick={() => {
                                            setModal(true);
                                            setForm({...form, nombre: '', tipo_usuario: '', id_tipo_usuario: 0});
                                            document.getElementById('id_tipo_usario').selectedIndex = 0;
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo_usuario",
                                                label: "Tipo",
                                                type: "text",
                                            },
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                <form onSubmit={handleSubmit}>
                    {isLoading && <LoadingSpinner/>}
                    <div className="card-body">
                        <h5 className="titulo_modal type_text mb-2">Crear equipo</h5>
                        <div className="form-group">
                            <Input
                                label="Nombre"
                                name="nombre"
                                value={form.nombre}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <label>Tipo</label>
                            <SelectInput
                                id="id_tipo_usario"
                                label="tipo"
                                name="id_tipo_usuario"
                                value={form.id_tipo_usuario}
                                select={form.tipo_usuario}
                                onChange={handleChange}
                                options={userTypes ? userTypes.map((item) => ({
                                    name: item.nombre,
                                    id: item.id,
                                })) : []}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        <button disabled={isLoading} onClick={() => {
                        }} className={`btn btn-calendar mb-1 button_div`}>Guardar
                        </button>
                        <button type="button" onClick={() => {
                            setModal(false);
                        }} className={`btn btn-outline-calendar button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
            <Footer/>
        </div>
    );
};

export default Teams;
